import { userConstants } from "../constants/login.constants";

 function individualEntitiesOffices(state = {}, action) {
    switch (action.type) {
        case userConstants.INDIVIDUALENTITIESOFFICES_REQUEST:
            return {
                loading: true
            };
        case userConstants.INDIVIDUALENTITIESOFFICES_SUCCESS:
            return {
                items: action.individualEntitiesOffices
            };
        case userConstants.INDIVIDUALENTITIESOFFICES_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default individualEntitiesOffices;